import queryString, { ParsedQuery } from 'query-string';

export const getQueryParams = (): ParsedQuery => {
  const search = window.location.search;

  return queryString.parse(search);
};
